(function () {
    'use strict';

angular.module('app')
    .directive('characterCounter', function () {
        return {
            templateUrl: 'components/directives/character_counter/view.character_counter.html',
            controller: 'CharacterCounterController',
            controllerAs: 'CharacterCounter',
            bindToController: true,
            restrict: 'E',
            scope: {
                current: '=',
                max: '=',
            }
        }
    });
})();
